// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"240":"116c72e5","564":"60ff3542"}[chunkId] + ".js";
};